import { GetLoansRes, GetValuationsRes } from '@dealstack/shared/lib/generated';

export enum HoldingTableColumn {
	type = 'type',
	name = 'name',
	volume = 'volume',
	value = 'value',
	cost = 'cost',
	vesting = 'vesting',
}

export type HoldingOrLoan =
	| GetValuationsRes
	| {
			type: GetLoansRes['type'];
			name: string;
			volume: string;
			value: number;
			cost: number;
	  };
